import { track } from "../track";

interface Params {
  quiz_id?: string;
  name?: string;
  email?: string;
}

export const trackOnBoToCourse = (params: Params) =>
  track({ event: "on_bo_to_course", ...params });
